export const BUILD_TIMESTAMP = '2025-05-12T15:31:45.386Z';
